import * as React from 'react';
export const useMemoizedHTML = function () {
  let rawHTML = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return React.useMemo(() => ({
    __html: rawHTML
  }), [rawHTML]);
};